import * as React from "react";

class DialogKText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="dialogK-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 287.538 218.229"
      >
        <g>
          <path
            fill="#F17752"
            d="M36.2,60.4l7.8,0l0,1.7l-5.7,0l0,3.7l4.9,0l0,1.8l-4.9,0l0,4.3l5.9,0l0,1.8l-8,0L36.2,60.4z"
          />
          <path
            fill="#F17752"
            d="M46.7,71c0-2.1,1.8-3.2,5.9-3.7c0-1.2-0.4-2.2-1.9-2.2c-1,0-2,0.5-2.9,1l-0.8-1.4c1-0.6,2.4-1.3,4-1.3
		c2.5,0,3.6,1.6,3.6,4.2l0,6l-1.7,0l-0.2-1.1h-0.1c-0.9,0.8-2,1.4-3.2,1.4C48,73.9,46.7,72.8,46.7,71z M52.7,71.1l0-2.4
		c-2.9,0.4-3.9,1.1-3.9,2.2c0,1,0.7,1.4,1.5,1.4C51.2,72.3,51.9,71.9,52.7,71.1z"
          />
          <path
            fill="#F17752"
            d="M57.2,72.5l1-1.3c0.9,0.7,1.7,1.1,2.8,1.1c1.2,0,1.7-0.6,1.7-1.3c0-0.9-1.1-1.3-2.2-1.7
		c-1.3-0.5-2.8-1.2-2.8-2.9c0-1.7,1.3-2.9,3.5-2.9c1.3,0,2.4,0.5,3.2,1.2l-1,1.3c-0.7-0.5-1.4-0.9-2.2-0.9c-1.1,0-1.6,0.5-1.6,1.2
		c0,0.8,1,1.2,2.1,1.6c1.4,0.5,2.9,1.1,2.9,3c0,1.7-1.3,3-3.8,3C59.5,73.9,58.1,73.3,57.2,72.5z"
          />
          <path
            fill="#F17752"
            d="M66.7,68.7c0-3.3,2.2-5.2,4.7-5.2c2.4,0,4.7,1.9,4.7,5.2c0,3.3-2.2,5.2-4.7,5.2C68.9,73.9,66.7,72,66.7,68.7z
		 M73.9,68.7c0-2.1-1-3.5-2.5-3.5c-1.5,0-2.5,1.4-2.5,3.5c0,2.1,1,3.5,2.5,3.5C72.9,72.2,73.9,70.8,73.9,68.7z"
          />
          <path
            fill="#F17752"
            d="M79,63.8h1.7l0.2,1.4h0.1c0.9-0.9,1.9-1.6,3.3-1.6c2.1,0,3,1.4,3,3.9l0,6.2h-2.1l0-6c0-1.7-0.5-2.4-1.7-2.4
		c-0.9,0-1.5,0.5-2.4,1.4l0,7l-2.1,0L79,63.8z"
          />
          <path
            fill="#F17752"
            d="M104.1,73.3c0.6,0,0.7-0.3,0.8-2.3c0.4,0.3,1.1,0.6,1.5,0.7c-0.2,2.5-0.6,3.2-2.2,3.2l-2.5,0
		c-1.8,0-2.3-0.5-2.3-2.1l0-4l-2.8,0c-0.3,3.6-1.2,5.5-5.7,6.5c-0.1-0.4-0.6-1.1-0.9-1.4c4-0.7,4.7-2.1,4.9-5l-4.6,0l0-1.6l15.9,0
		l0,1.6l-5,0l0,4c0,0.5,0.1,0.6,0.8,0.6L104.1,73.3z M92.3,64.7h-1.7l0-4.2l6.8,0c-0.2-0.5-0.5-1.2-0.8-1.6l1.7-0.5
		c0.4,0.6,0.8,1.5,1.1,2.1l6.2,0l0,4.2h-1.7l0-2.6l-11.6,0L92.3,64.7z M93.4,65.3l0-1.5l9.5,0l0,1.5L93.4,65.3z"
          />
          <path
            fill="#F17752"
            d="M117.5,73.1l6.8,0l0,1.5l-15.2,0l0-1.5l6.6,0l0-2.6l-4.8,0V69l4.8,0l0-2.4l-4,0l0-1.5c-0.8,0.6-1.6,1-2.3,1.4
		c-0.2-0.4-0.7-1-1-1.4c2.1-0.9,4.6-2.7,6.4-4.5l-2.9,0l0-1.6l5.7,0c1.6,2.4,4.6,4.7,7.5,5.9c-0.3,0.3-0.9,1-1.1,1.5
		c-0.8-0.4-1.6-0.8-2.3-1.3l0,1.4l-4.1,0l0,2.4l4.9,0l0,1.5l-4.9,0L117.5,73.1z M111.8,65.1l9.8,0c-1.9-1.2-3.6-2.8-4.9-4.4
		C115.4,62.2,113.6,63.8,111.8,65.1z"
          />
          <path
            fill="#F17752"
            d="M137.3,61.5c-0.4,0.6-0.8,1.2-1.2,1.9l0,11.7l-1.8,0l0-9.5c-1.7,1.9-3.8,3.6-6.1,4.9c-0.3-0.5-0.8-1.1-1.2-1.5
		c3.4-1.7,6.4-4.6,8.1-7.5l-7.6,0l0-1.7l15.4,0l0,1.7L137.3,61.5z M137.5,64.3c2,1.4,4.8,3.4,6.1,4.8l-1.4,1.3
		c-1.2-1.4-3.9-3.5-5.9-5L137.5,64.3z"
          />
          <path
            fill="#F17752"
            d="M160.9,60.8c-1.6,1.7-4,3.6-6.2,4.9l0,7.4c0,1-0.3,1.5-1,1.8c-0.8,0.3-2,0.3-3.8,0.3c-0.1-0.5-0.4-1.2-0.7-1.7
		c1.4,0.1,2.8,0.1,3.2,0c0.4,0,0.5-0.1,0.5-0.4l0-8.2c1.6-0.8,3.3-2.1,4.6-3.3l-11,0v-1.7l12.6,0l0.4-0.1L160.9,60.8z"
          />
          <path
            fill="#F17752"
            d="M176.1,60.9c-0.4,2.1-1.2,3.8-3.4,4.8c-0.2-0.3-0.5-0.8-0.8-1l0,8.8c0,0.7-0.1,1.2-0.6,1.4
		c-0.5,0.2-1.2,0.3-2.4,0.3c-0.1-0.4-0.3-1-0.5-1.4c0.9,0,1.6,0,1.8,0c0.2,0,0.3-0.1,0.3-0.3l0-2.9l-4,0c-0.2,1.7-0.5,3.4-1.4,4.7
		c-0.3-0.2-0.9-0.6-1.2-0.7c1.2-1.9,1.3-4.5,1.3-6.6l0-2.9l-0.2,0.2c-0.3-0.3-0.9-0.8-1.2-1c1.2-1.3,2.2-3.4,2.7-5.6l1.5,0.3
		c-0.1,0.4-0.3,0.9-0.4,1.3l1.9,0l0.2-0.1l1,0.6c-0.3,0.8-0.7,1.6-1.1,2.4h2.1l0,1.3c1.7-0.8,2.4-2,2.6-3.5l-2.2,0v-1.4l7.8,0
		c0,0,0,0.4,0,0.6c-0.1,2.9-0.3,4.1-0.7,4.6c-0.3,0.3-0.6,0.5-1,0.5c-0.4,0.1-1.1,0.1-1.8,0c0-0.4-0.2-1-0.4-1.4
		c0.6,0.1,1.2,0.1,1.5,0.1c0.2,0,0.4,0,0.5-0.2c0.2-0.2,0.3-1,0.4-2.8L176.1,60.9z M167.2,61.5c-0.2,0.6-0.5,1.1-0.8,1.6l1.8,0
		c0.2-0.5,0.5-1.1,0.7-1.6H167.2z M166.6,67.9c0,0.4,0,0.8,0,1.3l1.4,0v-1.8h-1.4V67.9z M166.6,66.1h1.4v-1.7l-1.4,0L166.6,66.1z
		 M170.5,69.2v-1.8h-1.4v1.8L170.5,69.2z M169.1,66.1h1.4v-1.7l-1.3,0L169.1,66.1z M180.6,71.9l-3.3,0l0,3.2l-1.6,0l0-3.2l-3.6,0
		v-1.5l3.6,0l0-1.9H174c-0.3,0.6-0.5,1.2-0.8,1.6c-0.3-0.2-0.9-0.5-1.3-0.7c0.7-1,1.3-2.5,1.6-4l1.4,0.3c-0.1,0.4-0.2,0.9-0.3,1.3
		h1.3l0-1.7l1.6,0V67l2.9,0l0,1.4l-2.9,0l0,1.9l3.3,0L180.6,71.9z"
          />
          <path
            fill="#F17752"
            d="M196.6,73.6c0.8,0,0.9-0.3,1-2.1c0.4,0.3,1.1,0.5,1.5,0.6c-0.2,2.4-0.7,3-2.3,3l-3.1,0c-2,0-2.5-0.5-2.5-2.1
		l0-3.7H191c-1,2.7-3,4.8-7.4,6c-0.2-0.4-0.6-1.1-0.9-1.4c3.8-0.9,5.6-2.6,6.5-4.6l-4.7,0l0-4.3c-0.3,0.2-0.6,0.5-0.9,0.7
		c-0.3-0.4-0.8-1-1.2-1.2c2.5-1.6,4.3-3.9,5.2-5.7l1.8,0.3c-0.2,0.3-0.4,0.7-0.6,1l4.1,0l0.3-0.1l1.2,0.8c-0.5,0.8-1.1,1.8-1.8,2.6
		l5.2,0l0,6l-4.8,0l0,3.7c0,0.6,0.2,0.7,1,0.7L196.6,73.6z M189.6,67.7c0.2-1,0.3-2,0.4-3l-4,0l0,3L189.6,67.7z M187.8,61.3
		c-0.5,0.6-1,1.3-1.6,1.9l4.2,0c0.5-0.6,1-1.3,1.4-1.9L187.8,61.3z M195.9,64.7l-4.1,0c-0.1,1.1-0.2,2.1-0.4,3l4.5,0L195.9,64.7z
		 M194.7,69.3c0.9,0.7,2,1.7,2.5,2.4l-1.2,1c-0.5-0.7-1.6-1.8-2.5-2.5L194.7,69.3z"
          />
          <path
            fill="#F17752"
            d="M215.1,73.6c0.8,0,0.9-0.3,1-2.1c0.4,0.3,1.1,0.5,1.5,0.6c-0.2,2.4-0.7,3-2.3,3l-3.1,0c-2,0-2.5-0.5-2.5-2.1
		l0-3.7h-0.2c-1,2.7-3,4.8-7.4,6c-0.2-0.4-0.6-1.1-0.9-1.4c3.8-0.9,5.6-2.6,6.5-4.6l-4.7,0l0-4.3c-0.3,0.2-0.6,0.5-0.9,0.7
		c-0.3-0.4-0.8-1-1.2-1.2c2.5-1.6,4.3-3.9,5.2-5.7l1.8,0.3c-0.2,0.3-0.4,0.7-0.6,1l4.1,0l0.3-0.1l1.2,0.8c-0.5,0.8-1.1,1.8-1.8,2.6
		l5.2,0l0,6l-4.8,0l0,3.7c0,0.6,0.2,0.7,1,0.7L215.1,73.6z M208.2,67.7c0.2-1,0.3-2,0.4-3l-4,0l0,3L208.2,67.7z M206.3,61.3
		c-0.5,0.6-1,1.3-1.6,1.9l4.2,0c0.5-0.6,1-1.3,1.4-1.9L206.3,61.3z M214.4,64.7l-4.1,0c-0.1,1.1-0.2,2.1-0.4,3l4.5,0L214.4,64.7z
		 M213.3,69.3c0.9,0.7,2,1.7,2.5,2.4l-1.2,1c-0.5-0.7-1.6-1.8-2.5-2.5L213.3,69.3z"
          />
          <path
            fill="#F17752"
            d="M235.8,61.3v1.6l-9.7,0c-0.6,1.3-1.3,2.5-2.1,3.6l0,8.6l-1.7,0l0-6.7c-0.6,0.6-1.2,1.1-1.9,1.6
		c-0.2-0.5-0.6-1.2-0.8-1.6c2-1.4,3.5-3.4,4.6-5.6l-4.1,0l0-1.6l4.9,0c0.4-0.9,0.6-1.8,0.9-2.6l1.7,0.4c-0.2,0.7-0.5,1.5-0.8,2.2
		L235.8,61.3z M231.2,73.2l4.5,0l0,1.6l-10.7,0l0-1.6l4.5,0l0-4.6l-3.9,0V67l3.9,0l0-3.2l1.7,0l0,3.2l3.8,0v1.5l-3.8,0L231.2,73.2z"
          />
          <path
            fill="#F17752"
            d="M241.6,69.2l0-4.2c-0.7,1.3-1.6,2.5-2.5,3.2c-0.3-0.4-0.8-0.9-1.1-1.2c1.3-0.9,2.5-2.6,3.3-4.3l-2.8,0l0-1.4
		l3.1,0l0-2.6h1.6l0,2.6l2.7,0l0,1.4l-2.7,0v0.9c0.7,0.4,2.5,1.7,2.9,2.1l-0.9,1.4c-0.4-0.5-1.3-1.2-2-1.9l0,4.1L241.6,69.2z
		 M238.2,73.5c0.7-1,1.3-2.4,1.6-3.7l1.5,0.6c-0.4,1.2-0.9,2.8-1.6,3.9L238.2,73.5z M248.5,73.3c0.8,0,1-0.3,1.1-2.1
		c0.4,0.3,1,0.5,1.5,0.6c-0.2,2.4-0.7,2.9-2.5,2.9l-3.5,0c-2.2,0-2.7-0.5-2.7-2l0-2.7l1.7,0l0,2.7c0,0.5,0.2,0.6,1.2,0.6L248.5,73.3
		z M246,68.7c0.8,0.8,1.9,1.8,2.5,2.5l-1.2,1c-0.5-0.7-1.6-1.8-2.4-2.6L246,68.7z M253.7,69l-7.1,0l0-9.4l7.1,0L253.7,69z
		 M252.1,66.2l-4,0l0,1.4l4,0V66.2z M252.1,63.6l-4,0l0,1.4l4,0V63.6z M252.1,60.9l-4,0l0,1.4l4,0V60.9z M252.4,69.5
		c0.7,1.1,1.7,2.6,2.2,3.6l-1.5,0.8c-0.4-0.9-1.4-2.5-2.1-3.7L252.4,69.5z"
          />
          <path
            fill="#F17752"
            d="M41,80.7c-0.5,1.2-1,2.4-1.7,3.6l0,12.4h-1.6l0-9.8c-0.5,0.8-1.1,1.5-1.7,2.1c-0.2-0.4-0.6-1.3-0.9-1.7
		c1.7-1.7,3.4-4.3,4.4-7L41,80.7z M51.6,87.9l-4.6,0l0,8.8l-1.7,0l0-8.8l-4.8,0l0-1.6l4.8,0l0-5.8l1.7,0l0,5.8l4.6,0L51.6,87.9z"
          />
          <path
            fill="#F17752"
            d="M57.3,83l0,3.5c0,2.9-0.2,7.3-1.6,10.2c-0.3-0.3-1-0.8-1.3-1c1.2-2.7,1.3-6.5,1.3-9.2l0-5l6.8,0
		c-0.1-0.4-0.2-0.8-0.4-1.2l1.7-0.3c0.2,0.5,0.4,1,0.5,1.5l6.2,0l0,1.5L57.3,83z M59.4,87.2c0,1-0.1,2.1-1,2.9
		c-0.2-0.2-0.6-0.6-0.8-0.7c0.8-0.6,0.9-1.5,0.9-2.2v-0.7l1,0V87.2z M67.6,92.3c0.9,1.1,2.2,2.7,2.9,3.6l-1.3,0.7
		c-0.2-0.3-0.4-0.7-0.7-1.1c-8.7,0.6-9.6,0.7-10.2,0.9c-0.1-0.3-0.3-1-0.4-1.4c0.5-0.1,1.2-0.3,2.1-0.8c0.5-0.2,1.4-0.7,2.4-1.3
		c-2.6,0.2-3.1,0.2-3.4,0.3c0-0.3-0.2-0.9-0.4-1.3c0.3,0,0.7-0.2,1.2-0.5c0.5-0.2,2.1-1.2,3.2-2.3L64,90c-1,0.8-2.1,1.5-3.1,2.1
		l3.1-0.1c0.8-0.5,1.7-1.1,2.4-1.7l1.3,0.9c-2.1,1.5-4.2,2.7-6.3,3.7l6-0.4c-0.4-0.5-0.8-1-1.2-1.4L67.6,92.3z M60.2,89.7l0-4
		l-2.1,0l0-1.3l2.1,0l0-0.9h1.3v0.9h2.2l0,1.3l-2.2,0l0,4H60.2z M65.7,87.1c0,0.9-0.1,1.9-1,2.7c-0.2-0.2-0.5-0.5-0.8-0.6v0.1
		c-0.1,0-0.4,0.1-0.6,0.1H63c-0.8,0-0.9-0.3-0.9-1.1l0-1.7h1l0,1.7c0,0.3,0,0.4,0.2,0.4h0h0c0.1,0,0.4,0,0.6-0.1l0.1,0.6
		c0.7-0.5,0.8-1.4,0.8-2l0-0.7h1L65.7,87.1z M66.4,89.7l0-3.9l-2.3,0l0-1.3l2.3,0l0-0.9l1.3,0l0,0.9l2.7,0l0,1.3l-2.7,0l0,3.9
		L66.4,89.7z M70,88.7c0.2,0,0.5,0,0.7-0.1l0.1,0.8c-0.1,0.1-0.4,0.1-0.7,0.1h-0.7c-0.8,0-1-0.4-1-1.2l0-1.9h1l0,2
		c0,0.3,0,0.4,0.2,0.4H70z"
          />
          <path
            fill="#F17752"
            d="M75.2,96c1.4-0.5,2.2-1.3,2.3-2.4c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.5-1.5-1.4c0-0.9,0.7-1.4,1.5-1.4
		c1.1,0,1.7,0.9,1.7,2.3c0,2-1.3,3.5-3.3,4.2L75.2,96z"
          />
          <path
            fill="#F17752"
            d="M93,82.7c-0.2,0.8-0.5,1.6-0.7,2.3l7.2,0l0,9.8c0,0.8-0.2,1.3-0.7,1.5c-0.6,0.3-1.5,0.3-2.7,0.3
		c-0.1-0.4-0.3-1.1-0.5-1.5c0.9,0,1.7,0,2,0c0.3,0,0.4-0.1,0.4-0.3l0-8.2l-2.6,0l0,9.6l-1.7,0l0-9.6l-2.5,0l0,9.6h-1.7l0-9.6l-2.4,0
		l0,10.2h-1.7l0-11.8l5.3,0c0.2-0.7,0.4-1.5,0.5-2.3l-6.8,0l0-1.7l16.1,0l0,1.7L93,82.7z"
          />
          <path
            fill="#F17752"
            d="M117.3,95.1c0.8,0,0.9-0.3,1-2.1c0.4,0.3,1.1,0.5,1.5,0.6c-0.2,2.4-0.7,3-2.3,3l-3.1,0c-2,0-2.5-0.5-2.5-2.1
		l0-3.7h-0.2c-1,2.7-3,4.8-7.4,6c-0.2-0.4-0.6-1.1-0.9-1.4c3.8-0.9,5.6-2.6,6.5-4.6l-4.7,0l0-4.3c-0.3,0.2-0.6,0.5-0.9,0.7
		c-0.3-0.4-0.8-1-1.2-1.2c2.5-1.6,4.3-3.9,5.2-5.7l1.8,0.3c-0.2,0.3-0.4,0.7-0.6,1l4.1,0l0.3-0.1l1.2,0.8c-0.5,0.8-1.1,1.8-1.8,2.6
		l5.2,0l0,6l-4.8,0l0,3.7c0,0.6,0.2,0.7,1,0.7L117.3,95.1z M110.3,89.3c0.2-1,0.3-2,0.4-3l-4,0l0,3L110.3,89.3z M108.5,82.9
		c-0.5,0.6-1,1.3-1.6,1.9l4.2,0c0.5-0.6,1-1.3,1.4-1.9L108.5,82.9z M116.6,86.3l-4.1,0c-0.1,1.1-0.2,2.1-0.4,3l4.5,0L116.6,86.3z
		 M115.4,90.9c0.9,0.7,2,1.7,2.5,2.4l-1.2,1c-0.5-0.7-1.6-1.8-2.5-2.5L115.4,90.9z"
          />
          <path
            fill="#F17752"
            d="M136.6,95.1c0.8,0,0.9-0.3,1-2.1c0.4,0.3,1.1,0.5,1.5,0.6c-0.2,2.4-0.7,3-2.3,3l-3.1,0c-2,0-2.5-0.5-2.5-2.1
		l0-3.7l-0.2,0c-1,2.7-3,4.8-7.4,6c-0.2-0.4-0.6-1.1-0.9-1.4c3.8-0.9,5.6-2.6,6.5-4.6l-4.7,0l0-4.3c-0.3,0.2-0.6,0.5-0.9,0.7
		c-0.3-0.4-0.8-1-1.2-1.2c2.5-1.6,4.3-3.9,5.2-5.7l1.8,0.3c-0.2,0.3-0.4,0.7-0.6,1l4.1,0l0.3-0.1l1.2,0.8c-0.5,0.8-1.1,1.8-1.8,2.6
		l5.2,0l0,6l-4.8,0l0,3.7c0,0.6,0.2,0.7,1,0.7L136.6,95.1z M129.6,89.3c0.2-1,0.3-2,0.4-3l-4,0l0,3L129.6,89.3z M127.8,82.9
		c-0.5,0.6-1,1.3-1.6,1.9l4.2,0c0.5-0.6,1-1.3,1.4-1.9L127.8,82.9z M135.9,86.3l-4.1,0c-0.1,1.1-0.2,2.1-0.4,3l4.5,0L135.9,86.3z
		 M134.7,90.9c0.9,0.7,2,1.7,2.5,2.4l-1.2,1c-0.5-0.7-1.6-1.8-2.5-2.5L134.7,90.9z"
          />
          <path
            fill="#F17752"
            d="M148.8,92c-1.4,1.8-3.5,3.6-5.4,4.8c-0.3-0.4-1-0.9-1.4-1.2c1.9-1.1,4-2.8,5-4.3L148.8,92z M156.3,81.5l0,8.3
		l-12.4,0l0-8.3L156.3,81.5z M145.6,88.2l8.9,0l0-5.1l-8.9,0L145.6,88.2z M153,91.2c1.7,1.3,3.9,3.2,5,4.5l-1.6,1
		c-1-1.2-3.1-3.2-4.9-4.6L153,91.2z"
          />
          <path
            fill="#F17752"
            d="M170.3,94.8c0.6,0.1,1.2,0.1,1.8,0.1c0.8,0,4.4,0,5.5,0c-0.2,0.4-0.5,1.1-0.6,1.6l-5,0c-3.4,0-5.7-0.5-7.2-2.8
		c-0.7,1.3-1.6,2.4-2.7,3.1c-0.3-0.3-0.9-0.9-1.2-1.2c1.8-1.2,3-3.1,3.4-5.7l1.7,0.2c-0.1,0.6-0.3,1.2-0.5,1.7
		c0.6,1.5,1.7,2.3,3.1,2.6l0-5l-7.2,0V88l15.8,0v1.5l-6.9,0l0,1.7l5.7,0l0,1.5l-5.7,0L170.3,94.8z M175.4,86.9l-12.1,0l0-6l12.1,0
		L175.4,86.9z M173.7,84.5l-8.8,0v1.2l8.8,0V84.5z M173.7,82.1l-8.8,0v1.2l8.8,0L173.7,82.1z"
          />
          <path
            fill="#F17752"
            d="M195.7,88.4c-0.5,1-1.4,1.9-2.3,2.6c1.1,0.5,2.4,0.9,3.7,1.1c-0.3,0.3-0.7,0.8-0.9,1.2c-0.3-0.1-0.7-0.1-1-0.2
		l0,3.7h-1.5v-0.4l-3.1,0v0.4l-1.4,0l0-3.7c-0.4,0.1-0.7,0.2-1.1,0.3c-0.1-0.3-0.3-0.6-0.5-0.9v0.9l-2.2,0l0,1.5
		c0.9-0.1,1.8-0.2,2.6-0.3l0,1.2c-2.6,0.3-5.3,0.5-7.3,0.7l-0.1-1.3l0.9-0.1l0-3.5h1.3l0,3.3l1.1-0.1l0-3.8l-2.2,0l0-3.5l5.8,0
		l0,2.2c1.5-0.8,2.6-1.8,3.2-2.8l1.3,0.2c-0.1,0.2-0.3,0.4-0.4,0.6l3,0l0.2-0.1L195.7,88.4z M182.6,86.3l-1.6,0l0-3.5l6.8,0l0-0.8
		l-6,0v-1.1l13.8,0V82l-6.2,0v0.8l7,0l0,3.5l-1.7,0l0-2.4l-5.3,0l0,3.6l-1.6,0l0-3.6l-5.2,0V86.3z M182.8,86.2
		c1-0.1,2.3-0.3,3.7-0.5c-0.7-0.3-2.1-0.7-3.2-1l0.5-0.8c1,0.2,2.4,0.6,3.1,0.9l-0.4,0.9l0.6-0.1l0.1,0.9c-1.4,0.3-2.7,0.6-3.9,0.8
		L182.8,86.2z M183,90.1l3,0l0-1.3l-3,0V90.1z M187.5,92.3c1.2-0.3,2.4-0.7,3.5-1.3c-0.5-0.3-0.9-0.8-1.3-1.2
		c-0.4,0.3-0.9,0.7-1.4,1c-0.2-0.3-0.6-0.6-0.9-0.8v1.3h-2.1v1H187.5z M190.3,85.5l0.3,0l-0.4-0.6c1-0.2,2.4-0.7,3.2-1l0.6,0.8
		c-0.9,0.4-2.1,0.7-3.1,0.9c1.2,0.2,2.7,0.5,3.5,0.8l-0.3,1c-1-0.4-2.8-0.8-4.2-1L190.3,85.5z M194.5,92.8c-0.8-0.3-1.6-0.6-2.3-1
		c-0.7,0.4-1.4,0.7-2.2,1L194.5,92.8z M190.7,89L190.7,89c0.3,0.5,0.8,1,1.5,1.4c0.6-0.4,1.1-0.9,1.6-1.3L190.7,89z M193.7,95.3
		v-1.4l-3.1,0l0,1.4L193.7,95.3z"
          />
          <path
            fill="#F17752"
            d="M215,89.1l0,7.6l-1.9,0v-1l-12.5,0l0-6.6l1.9,0l0,4.9l4.4,0l0-6l-5.4,0l0-6.3l1.8,0l0,4.7l3.6,0l0-6.2h1.9
		l0,6.2l3.7,0l0-4.7l1.9,0l0,6.3l-5.6,0l0,6l4.4,0l0-4.9L215,89.1z"
          />
          <path
            fill="#F17752"
            d="M225.3,83.8c-0.5,1.3-1.2,2.6-2.1,3.8c0.7,0.7,2,2,2.3,2.3l-1,1.4c-0.3-0.5-1-1.3-1.6-2l0,7.4l-1.5,0l0-6.9
		c-0.7,0.7-1.4,1.3-2.1,1.8c-0.1-0.5-0.4-1.3-0.6-1.7c1.8-1.1,3.6-3.1,4.6-5.1l-4.2,0v-1.5l3.3,0c-0.3-0.6-1-1.6-1.5-2.3l1.3-0.7
		c0.6,0.7,1.3,1.7,1.6,2.3l-1.2,0.8l1.7,0l0.3-0.1L225.3,83.8z M234.8,82.9l0,9.5h-1.6v-0.7l-2.1,0l0,5h-1.6l0-5l-2.1,0v0.8h-1.5
		l0-9.7l3.6,0l0-2.7l1.6,0l0,2.7L234.8,82.9z M229.4,90.3l0-2.2l-2.1,0l0,2.2L229.4,90.3z M227.3,84.4l0,2.2l2.1,0l0-2.2L227.3,84.4
		z M233.2,90.3l0-2.2l-2.1,0v2.2L233.2,90.3z M231,84.4l0,2.2l2.1,0l0-2.2L231,84.4z"
          />
          <path
            fill="#F17752"
            d="M243.4,91.4c-0.2-0.5-0.6-1.4-1-2.2l0,7.5h-1.5l0-6.8c-0.6,1.5-1.2,2.8-1.9,3.8c-0.2-0.5-0.6-1.2-0.8-1.6
		c1-1.2,2-3.4,2.6-5.3l-2.1,0v-1.5l2.3,0l0-2.6c-0.6,0.1-1.2,0.2-1.7,0.3c-0.1-0.4-0.3-0.9-0.5-1.3c1.7-0.3,3.6-0.8,4.8-1.4l1,1.4
		c-0.6,0.3-1.3,0.5-2,0.7l0,3l2,0l0,1.5l-2,0l0,0.3c0.5,0.6,1.7,2.4,2,2.8c0.4-1.3,0.6-3,0.7-4.3l1.3,0.3c-0.2,1.8-0.5,4.3-1.2,5.7
		l-1.3-0.5c0.1-0.4,0.3-0.8,0.4-1.2L243.4,91.4z M251.3,95.1c0.6,0,0.7-0.5,0.8-2.6c0.4,0.3,1,0.5,1.4,0.6c-0.2,2.6-0.6,3.4-2,3.4
		l-2.3,0c-1.6,0-2-0.5-2.1-2c-0.6,0.7-1.4,1.3-2.1,1.9c-0.3-0.3-1-0.9-1.3-1.1c1.3-0.9,2.4-2,3.5-3.2l0-7.8l1.6,0l0,5.5
		c1.5-2.4,2.6-5.3,3.4-8.4l1.6,0.3c-0.5,1.8-1.1,3.5-1.7,5.1l1.1-0.3c0.7,1.7,1.4,3.8,1.7,5.2l-1.5,0.4c-0.2-1.3-0.8-3.3-1.4-4.9
		c-0.9,2-1.9,3.8-3.1,5.4v1.6c0,0.7,0.1,0.9,0.7,0.9L251.3,95.1z M250,84c-0.7-0.8-2.2-1.9-3.3-2.7l1-1.1c1.1,0.7,2.7,1.8,3.4,2.5
		L250,84z"
          />
          <path
            fill="#F17752"
            d="M51.2,104.6c0,0,0,0.6,0,0.8c-0.3,8.1-0.5,10.9-1.2,11.8c-0.5,0.6-0.9,0.8-1.6,0.8c-0.6,0.1-1.7,0.1-2.7,0
		c0-0.5-0.2-1.2-0.5-1.6c1.2,0.1,2.2,0.1,2.6,0.1c0.4,0,0.6-0.1,0.8-0.3c0.6-0.6,0.8-3.3,1-10.1l-4.2,0c-0.5,1.2-1.1,2.2-1.6,3
		c-0.3-0.3-0.9-0.7-1.3-0.9l0,8.3l-4.9,0v1.4l-1.5,0l0-13.2l2,0c0.3-0.9,0.5-2.1,0.6-2.9l1.8,0.3c-0.3,0.9-0.6,1.9-0.9,2.6l2.9,0
		l0,3.4c1.2-1.5,2.1-3.9,2.7-6.3l1.6,0.4c-0.2,0.8-0.5,1.7-0.7,2.4L51.2,104.6z M40.8,115l0-4l-3.3,0l0,4L40.8,115z M37.5,106.1
		l0,3.4l3.3,0l0-3.4L37.5,106.1z M46.8,113.6c-0.5-1.1-1.7-2.9-2.6-4.2l1.3-0.7c1,1.2,2.2,3,2.7,4L46.8,113.6z"
          />
          <path
            fill="#F17752"
            d="M58.6,105.9c-0.3,0.7-0.6,1.4-1,2.2l0,10.2l-1.5,0l0-7.8c-0.4,0.5-0.7,1-1.1,1.4c-0.2-0.3-0.6-1.1-0.8-1.5
		c1.2-1.2,2.4-3.1,3.1-4.9L58.6,105.9z M58.3,102.3c-0.8,1.5-2,3.1-3.2,4.2c-0.2-0.3-0.6-1-0.8-1.3c1-0.9,2.1-2.4,2.6-3.5
		L58.3,102.3z M60.7,111c-0.1,3.3-0.3,5.7-1.9,7.1c-0.2-0.4-0.6-1-1-1.2c1.3-1.1,1.4-3,1.5-5.9L60.7,111z M58.5,109l6,0l0,1.3l-6,0
		L58.5,109z M64.6,108l-5.9,0l0-4.6l1.2,0l0,3.3H61l0-5l1.3,0l0,5h1l0-3.3l1.2,0L64.6,108z M65,113.4c0.1,0.4,0.3,0.9,0.4,1.2
		c-2.3,1.5-2.7,1.9-3,2.2c-0.1-0.4-0.4-1.1-0.6-1.4c0.3-0.1,0.6-0.5,0.6-1.2l0-3.1l1.4,0l0,3.1L65,113.4z M70.1,106.5
		c-0.3,2.8-0.8,5.2-1.6,7.2c0.6,1.4,1.5,2.4,2.6,3.2c-0.3,0.3-0.8,0.9-1,1.2c-1-0.7-1.7-1.7-2.3-2.8c-0.7,1.2-1.5,2.2-2.6,3
		c-0.2-0.3-0.7-0.9-1-1.1c1.3-0.9,2.2-2.1,2.9-3.5c-0.5-1.4-0.9-2.9-1.1-4.6c-0.2,0.3-0.4,0.7-0.6,1c-0.2-0.3-0.6-1-1-1.3
		c1.2-1.7,1.8-4.2,2.2-6.9l1.4,0.2c-0.2,1.1-0.4,2.1-0.6,3.1l3.5,0l0,1.4L70.1,106.5z M67,106.5c0,0.1-0.1,0.3-0.1,0.4
		c0.2,1.7,0.5,3.4,1,4.8c0.5-1.5,0.7-3.3,0.9-5.2L67,106.5z"
          />
          <path
            fill="#F17752"
            d="M76.6,104.7c-0.6,0.9-1.2,1.8-1.8,2.4c-0.3-0.3-0.8-0.9-1.2-1.2c1.1-1.1,2.2-2.7,2.7-4.4l1.6,0.4
		c-0.2,0.4-0.3,0.8-0.5,1.2l4.3,0v1.4l-3.4,0c0.7,0.6,1.6,1.4,2,1.9l-1.1,1c-0.5-0.6-1.4-1.5-2.1-2.2l0.8-0.7L76.6,104.7z
		 M83.5,112.9c1.3,2,3.6,3.4,6.5,4c-0.4,0.3-0.8,1-1.1,1.5c-3.2-0.8-5.5-2.5-7-5c-1,2.2-3,4-7.1,5c-0.2-0.4-0.6-1.1-0.9-1.4
		c3.6-0.8,5.4-2.2,6.2-4l-6.2,0l0-1.5l6.8,0c0.2-0.6,0.3-1.3,0.4-2c-1.9,0.2-3.8,0.2-5.5,0.3c0-0.4-0.2-1-0.4-1.4
		c3.9-0.1,8.5-0.5,11.6-1.1c-0.5-0.5-1.2-1.2-1.8-1.8l0.8-0.7l-1.6,0c-0.5,0.9-0.9,1.7-1.5,2.3c-0.3-0.3-0.9-0.8-1.3-1
		c1-1.1,1.8-2.7,2.3-4.4l1.6,0.3c-0.1,0.5-0.3,0.9-0.5,1.3l5.2,0l0,1.4l-3.7,0c0.6,0.5,1.3,1.2,1.7,1.6l-0.8,0.8
		c0.2-0.1,0.4-0.1,0.6-0.1l1,1.4c-1.6,0.4-3.6,0.7-5.7,0.9c-0.1,0.7-0.2,1.5-0.4,2.2l7.4,0l0,1.5L83.5,112.9z"
          />
          <path
            fill="#F17752"
            d="M94.3,117.6c1.4-0.5,2.2-1.3,2.3-2.4c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.5-1.5-1.4c0-0.9,0.7-1.4,1.5-1.4
		c1.1,0,1.7,0.9,1.7,2.3c0,2-1.3,3.5-3.3,4.2L94.3,117.6z"
          />
          <path
            fill="#F17752"
            d="M118.6,116.3c0,1-0.2,1.5-0.9,1.8c-0.7,0.3-1.8,0.3-3.4,0.3c-0.1-0.5-0.3-1.2-0.6-1.7c1.2,0.1,2.4,0.1,2.8,0
		c0.4,0,0.5-0.1,0.5-0.4l0-9.8l-11.2,0l0,11.8l-1.7,0l0-13.5l4.9,0c0.4-1,0.8-2.2,1-3.1l2.1,0.3c-0.4,0.9-0.9,1.9-1.3,2.7l7.8,0
		L118.6,116.3z M109.3,114.6l0,1.3h-1.5l0-7.3l7,0l0,6L109.3,114.6z M109.3,110l0,3l3.9,0l0-3L109.3,110z"
          />
          <path
            fill="#F17752"
            d="M123.3,103.6l7.8,0l0,1.7l-5.7,0l0,3.7l4.9,0l0,1.8l-4.9,0l0,4.3l5.9,0l0,1.8l-8,0L123.3,103.6z"
          />
          <path
            fill="#F17752"
            d="M134.3,114.3c0-2.1,1.8-3.2,5.9-3.7c0-1.2-0.4-2.2-1.9-2.2c-1,0-2,0.5-2.9,1l-0.8-1.4c1-0.6,2.4-1.3,4-1.3
		c2.5,0,3.6,1.6,3.6,4.2l0,6l-1.7,0l-0.2-1.1h-0.1c-0.9,0.8-2,1.4-3.2,1.4C135.5,117.1,134.3,116,134.3,114.3z M140.2,114.4l0-2.4
		c-2.9,0.4-3.9,1.1-3.9,2.2c0,1,0.7,1.4,1.5,1.4C138.7,115.5,139.4,115.1,140.2,114.4z"
          />
          <path
            fill="#F17752"
            d="M145.4,115.8l1-1.3c0.9,0.7,1.7,1.1,2.8,1.1c1.2,0,1.7-0.6,1.7-1.3c0-0.9-1.1-1.3-2.2-1.7
		c-1.3-0.5-2.8-1.2-2.8-2.9c0-1.7,1.3-2.9,3.5-2.9c1.3,0,2.4,0.5,3.2,1.2l-1,1.3c-0.7-0.5-1.4-0.9-2.2-0.9c-1.1,0-1.6,0.5-1.6,1.2
		c0,0.8,1,1.2,2.1,1.6c1.4,0.5,2.9,1.1,2.9,3c0,1.7-1.3,3-3.8,3C147.7,117.1,146.3,116.6,145.4,115.8z"
          />
          <path
            fill="#F17752"
            d="M155.6,112c0-3.3,2.2-5.2,4.7-5.2c2.4,0,4.7,1.9,4.7,5.2c0,3.3-2.2,5.2-4.7,5.2
		C157.8,117.1,155.6,115.3,155.6,112z M162.8,112c0-2.1-1-3.5-2.5-3.5c-1.5,0-2.5,1.4-2.5,3.5c0,2.1,1,3.5,2.5,3.5
		C161.8,115.5,162.8,114.1,162.8,112z"
          />
          <path
            fill="#F17752"
            d="M168.3,107l1.7,0l0.2,1.4h0.1c0.9-0.9,1.9-1.6,3.3-1.6c2.1,0,3,1.4,3,3.9l0,6.2l-2.1,0l0-6
		c0-1.7-0.5-2.4-1.7-2.4c-0.9,0-1.5,0.5-2.4,1.3l0,7l-2.1,0L168.3,107z"
          />
          <path
            fill="#F17752"
            d="M196.1,111.7c-1,0.8-2.3,1.7-3.3,2.3c1.2,1.1,2.6,1.9,4.3,2.4c-0.4,0.4-0.8,1-1.1,1.5
		c-3.7-1.2-6.1-3.9-7.5-7.6c-0.7,0.8-1.6,1.5-2.6,2.2l0,3.6l4.1-1.2c0,0.5,0.2,1.1,0.3,1.5c-5,1.5-5.7,1.8-6.2,2.1
		c-0.1-0.4-0.5-1.2-0.7-1.5c0.3-0.2,0.8-0.5,0.8-1.3l0-2.1c-0.9,0.5-1.9,1-2.8,1.3c-0.3-0.4-0.7-1-1.1-1.4c2.1-0.7,4.5-1.9,6.1-3.3
		l-5.5,0l0-1.4l6.9,0v-1.4l-5.3,0V106l5.3,0l0-1.3l-6.2,0l0-1.4l6.2,0l0-1.4h1.7v1.4l6.4,0v1.4l-6.4,0v1.3l5.7,0v1.4l-5.7,0v1.3l7,0
		v1.4l-6.3,0c0.4,1,1,2,1.7,2.8c1-0.7,2.2-1.6,2.9-2.3L196.1,111.7z"
          />
          <path
            fill="#F17752"
            d="M204.7,111.2c-0.8,2.2-2.2,4.3-3.5,5.7c-0.4-0.3-1.1-0.8-1.6-1c1.4-1.2,2.6-3.2,3.3-5.1L204.7,111.2z
		 M208.8,109l0,9.3l-1.8,0l0-9.3l-6.9,0v-1.7l15.8,0l0,1.7L208.8,109z M214.3,104.7l-12.6,0l0-1.7l12.6,0L214.3,104.7z M213,110.6
		c1.3,1.7,2.6,3.9,3.2,5.4l-1.7,0.8c-0.5-1.5-1.7-3.8-3-5.5L213,110.6z"
          />
          <path
            fill="#F17752"
            d="M235,111.5c0,0,0,0.5-0.1,0.7c-0.3,3.6-0.6,5.1-1.2,5.7c-0.4,0.4-0.7,0.5-1.2,0.5c-0.5,0.1-1.3,0.1-2.2,0
		c0-0.5-0.2-1.1-0.4-1.5c0.8,0.1,1.5,0.1,1.9,0.1c0.3,0,0.5,0,0.6-0.2c0.3-0.3,0.6-1.4,0.8-3.8l-10.7,0c-0.9,0.7-1.8,1.3-2.9,1.8
		c-0.2-0.4-0.6-1.1-0.9-1.4c3.2-1.6,5.5-4,7.2-6.9l-6.1,0l0-1.5l3.3,0c-0.3-0.7-0.8-1.7-1.3-2.5l1.4-0.6c0.6,0.8,1.2,1.9,1.4,2.6
		l-0.9,0.4l2.9,0c0.5-1,0.9-2.1,1.3-3.1l1.7,0.5c-0.3,0.9-0.7,1.8-1.1,2.6l3.6,0c-0.2,1.1-0.4,2.3-0.6,3.3l2.1,0
		c-0.2,1.1-0.4,2.3-0.6,3.3H235z M219.5,117.4c1-0.8,1.7-2.2,2-3.7l1.4,0.5c-0.4,1.5-1,3.1-2.1,4L219.5,117.4z M225.3,114.2
		c0.3,1,0.5,2.4,0.5,3.3l-1.5,0.2c0.1-0.9-0.1-2.2-0.4-3.3L225.3,114.2z M225.8,109.6c-0.5,0.6-1.1,1.2-1.6,1.8l7.4,0
		c0.1-0.5,0.3-1.2,0.4-1.8L225.8,109.6z M227.9,113.9c0.4,0.9,0.8,2.1,1,2.9l-1.3,0.4c-0.1-0.8-0.5-2-0.9-2.9L227.9,113.9z
		 M228,106.4c-0.3,0.6-0.7,1.2-1.1,1.8l3.3,0c0.1-0.5,0.3-1.1,0.4-1.8L228,106.4z M230.4,116.3c-0.2-0.7-0.7-1.7-1.2-2.4l1.2-0.4
		c0.5,0.7,1.1,1.7,1.3,2.3L230.4,116.3z"
          />
          <path
            fill="#F17752"
            d="M253.6,104.1c-1.6,1.7-4,3.6-6.2,4.9l0,7.4c0,1-0.3,1.5-1,1.8c-0.8,0.3-2,0.3-3.8,0.3
		c-0.1-0.5-0.4-1.2-0.7-1.7c1.4,0.1,2.8,0.1,3.2,0c0.4,0,0.5-0.1,0.5-0.4l0-8.2c1.6-0.8,3.3-2.1,4.6-3.3l-11,0v-1.7l12.6,0l0.4-0.1
		L253.6,104.1z"
          />
          <path
            fill="#F17752"
            d="M51.5,136.1l-3.6,0l0,2.1c0,0.8-0.2,1.3-0.8,1.5c-0.6,0.2-1.6,0.3-3.1,0.3c-0.1-0.5-0.3-1.1-0.6-1.5
		c1.1,0,2.1,0,2.4,0c0.3,0,0.4-0.1,0.4-0.3l0-2l-6.3,0c0.8,0.5,1.7,1.2,2.2,1.8l-1.2,1c-0.5-0.7-1.7-1.6-2.7-2.2l0.7-0.6l-3.7,0
		l0-1.4l10.9,0l0-1l-2.6,0l0-3.8l6.8,0l0,3.8l-2.6,0l0,1l3.6,0L51.5,136.1z M35.6,132.8c0.8,0,1.7-0.1,2.8-0.1l0-1.5l-2.5,0l0-1.2
		l6.6,0l0,1.2H40l0,1.4l2.9-0.2l0,1.2c-2.6,0.2-5.2,0.4-7.1,0.5L35.6,132.8z M47.5,127.1l-11.4,0V126l11.4,0l0-0.9l-10.2,0l0-1.1
		l11.8,0l0,2l1.4,0v1.1l-1.4,0l0,2.1l-11.9,0l0-1.2l10.3,0L47.5,127.1z M45.3,132.6l3.6,0l0-1.5l-3.6,0L45.3,132.6z"
          />
          <path
            fill="#F17752"
            d="M60,132.5c-0.7,0.2-1.5,0.4-2.3,0.7l0,4.7c0,0.9-0.2,1.3-0.7,1.5c-0.5,0.3-1.3,0.3-2.6,0.3
		c-0.1-0.4-0.3-1.1-0.5-1.5c0.8,0,1.5,0,1.8,0c0.3,0,0.3-0.1,0.3-0.4l0-4.2l-2.2,0.6l-0.4-1.6c0.7-0.2,1.6-0.4,2.6-0.6l0-3.5l-2.4,0
		l0-1.5l2.4,0l0-3.5l1.6,0l0,3.5l2.1,0l0,1.5l-2.1,0l0,3.1c0.7-0.2,1.4-0.4,2.1-0.6L60,132.5z M69,130.8c-0.7,1.7-1.9,3.3-3.2,4.7
		c0.6,1.4,1.3,2.2,2.2,2.3c0.5,0,0.7-0.9,0.9-2.8c0.3,0.4,1.1,0.8,1.4,1c-0.4,3.1-1.2,4-2.2,3.9c-1.6-0.1-2.8-1.2-3.6-3
		c-1.2,1-2.4,1.9-3.7,2.5c-0.3-0.4-0.9-1-1.4-1.3c1.6-0.6,3.1-1.6,4.4-2.8c-0.5-1.5-0.8-3.4-1.1-5.5l-2.5,0.3l-0.2-1.6l2.5-0.2
		c-0.1-1.5-0.2-3-0.3-4.6l1.7,0c0.1,1.5,0.1,3,0.3,4.4l5.4-0.6l0.2,1.6l-5.4,0.6c0.2,1.6,0.5,3.1,0.8,4.3c1-1.2,1.8-2.5,2.4-3.8
		L69,130.8z M67.3,127.2c-0.5-0.8-1.5-1.9-2.4-2.7l1.3-0.8c0.8,0.8,1.9,1.9,2.5,2.6L67.3,127.2z"
          />
          <path
            fill="#F17752"
            d="M87.5,135.3c-0.9,0.6-2,1.3-3,1.7c1.1,0.6,2.5,1.1,4.1,1.4c-0.3,0.3-0.7,0.9-0.9,1.3c-3.6-0.7-6-2.4-7.3-5.2
		c-0.8,0.6-1.8,1.2-2.9,1.7l0,1.9l3.8-0.8c-0.1,0.4-0.1,1-0.1,1.2c-4.5,1.1-5.1,1.2-5.5,1.5v-0.1c-0.1-0.4-0.4-0.9-0.5-1.1
		c0.3-0.2,0.8-0.6,0.8-1.5v-0.5c-1,0.4-2,0.6-3,0.8c-0.2-0.3-0.6-0.9-0.9-1.2c2.2-0.3,4.5-1.1,6.2-2l-5.9,0l0-1.3l7.4,0
		c-0.1-0.4-0.3-0.7-0.5-1l0.3-0.1c-0.3,0-0.6,0-1,0c-0.1-0.3-0.3-0.7-0.4-1c0.5,0,1,0,1.1,0c0.2,0,0.2-0.1,0.2-0.2l0-1.1l-1.9,0
		l0,2.8h-1.4l0-2.8l-1.8,0l0,2.4l-1.3,0l0-3.4l3.1,0l0-0.8l-3.9,0l0-1.2l1.2,0c-0.3-0.2-0.8-0.5-1-0.6c0.6-0.7,1.1-1.7,1.4-2.7
		l1.3,0.3c-0.1,0.3-0.2,0.6-0.3,0.9l1.4,0v-1.2l1.4,0v1.2l3.1,0l0,1.1l-3.1,0l0,0.9l3.6,0l0,1.2l-3.6,0l0,0.8l3.2,0l0,2.1
		c0,0.5-0.1,0.8-0.3,1l0.3-0.1c0.3,0.5,0.6,1,0.8,1.5l6.7,0l0,1.3l-6.4,0c0.4,0.7,0.9,1.3,1.5,1.8c1-0.5,2.2-1.2,3-1.8L87.5,135.3z
		 M76.2,126.7l0-0.9l-2,0c-0.2,0.3-0.4,0.6-0.6,0.9L76.2,126.7z M84,130.2h-1.5l0-5.9H84L84,130.2z M87.4,130.8
		c0,0.8-0.2,1.2-0.7,1.4c-0.5,0.2-1.4,0.3-2.6,0.3c-0.1-0.4-0.3-1-0.5-1.4c0.9,0,1.8,0,2,0c0.3,0,0.3-0.1,0.3-0.3l0-7.3h1.5
		L87.4,130.8z"
          />
          <path
            fill="#F17752"
            d="M96.3,124c-0.5,1.3-1.1,2.6-1.8,3.8l0,12.2l-1.7,0l0-9.5c-0.5,0.6-1,1.2-1.5,1.8c-0.2-0.4-0.6-1.4-0.9-1.7
		c1.7-1.7,3.3-4.3,4.3-6.9L96.3,124z M101.7,127.9l0,2.3l4.9,0l0,1.5l-4.9,0l0,2.4l5.1,0l0,1.6l-5.1,0l0,4.2l-1.7,0l0-12l-1,0
		c-0.8,1.4-1.6,2.7-2.5,3.6c-0.3-0.3-0.9-0.9-1.3-1.1c1.6-1.7,3-4.2,3.9-6.8l1.6,0.4c-0.3,0.8-0.6,1.6-0.9,2.3l7.2,0l0,1.6
		L101.7,127.9z"
          />
          <path
            fill="#F17752"
            d="M121,125.7c-0.4,2.1-1.2,3.8-3.4,4.8c-0.2-0.3-0.5-0.8-0.8-1l0,8.8c0,0.7-0.1,1.2-0.6,1.4
		c-0.5,0.2-1.2,0.3-2.4,0.3c-0.1-0.4-0.3-1-0.5-1.4c0.9,0,1.6,0,1.8,0c0.2,0,0.3-0.1,0.3-0.3l0-2.9l-4,0c-0.2,1.7-0.5,3.4-1.4,4.7
		c-0.3-0.2-0.9-0.6-1.2-0.7c1.2-1.9,1.3-4.5,1.3-6.6l0-2.9L110,130c-0.3-0.3-0.9-0.8-1.2-1c1.2-1.4,2.2-3.4,2.7-5.6l1.5,0.3
		c-0.1,0.4-0.3,0.9-0.4,1.3h1.9l0.2-0.1l1,0.6c-0.3,0.8-0.7,1.6-1.1,2.4l2.1,0v1.3c1.7-0.8,2.4-2,2.6-3.5l-2.2,0l0-1.4l7.8,0
		c0,0,0,0.4,0,0.6c-0.1,2.9-0.3,4.1-0.7,4.6c-0.3,0.3-0.6,0.5-1,0.5c-0.4,0.1-1.1,0.1-1.8,0c0-0.4-0.2-1-0.4-1.4
		c0.6,0.1,1.2,0.1,1.5,0.1c0.2,0,0.4,0,0.5-0.2c0.2-0.2,0.3-1,0.4-2.8L121,125.7z M112.1,126.3c-0.2,0.6-0.5,1.1-0.8,1.6h1.8
		c0.2-0.5,0.5-1.1,0.7-1.6L112.1,126.3z M111.5,132.7c0,0.4,0,0.8,0,1.3l1.4,0l0-1.8l-1.4,0L111.5,132.7z M111.5,130.9l1.4,0l0-1.7
		h-1.4L111.5,130.9z M115.4,134l0-1.8l-1.4,0l0,1.8L115.4,134z M114.1,130.9l1.4,0l0-1.7h-1.4L114.1,130.9z M125.5,136.7l-3.3,0
		l0,3.2h-1.6l0-3.2l-3.6,0l0-1.5l3.6,0l0-1.9l-1.8,0c-0.3,0.6-0.5,1.2-0.8,1.6c-0.3-0.2-0.9-0.5-1.3-0.7c0.7-1,1.3-2.5,1.5-4
		l1.4,0.3c-0.1,0.4-0.2,0.9-0.3,1.3l1.3,0l0-1.7h1.6l0,1.7l2.9,0l0,1.4l-2.9,0l0,1.9l3.3,0L125.5,136.7z"
          />
          <path
            fill="#F17752"
            d="M134.1,136.6c-1.3,1.3-3.6,2.4-5.7,2.9c-0.2-0.4-0.7-1-1-1.3c2-0.4,4.3-1.2,5.5-2.1L134.1,136.6z M136.5,135.8
		l0,4.1l-1.7,0l0-4.1l-7,0l0-1.3l7,0v-1h-1.9l0-5.8l1.7,0c0.2-0.5,0.3-1.1,0.4-1.5l1.6,0.3c-0.2,0.4-0.4,0.8-0.5,1.2l2.3,0l0,5.8
		l-2,0l0,1l7.1,0l0,1.3L136.5,135.8z M131.9,134.1c0-0.2-0.1-0.4-0.1-0.7c-2.6,0.3-3.1,0.4-3.3,0.5c-0.1-0.2-0.3-0.9-0.4-1.2
		c0.3-0.1,0.6-0.3,1-0.8c0.2-0.2,0.6-0.7,1-1.3c-1.3,0.1-1.7,0.2-1.9,0.3c-0.1-0.3-0.3-0.9-0.4-1.2c0.2,0,0.5-0.3,0.7-0.6
		c0.2-0.3,1-1.4,1.4-2.6l1.2,0.5c-0.4,0.9-1,1.8-1.6,2.5l1.4-0.1c0.3-0.4,0.5-0.9,0.8-1.3l1.2,0.6c-0.9,1.3-1.9,2.6-2.9,3.7l1.6-0.2
		c-0.1-0.4-0.3-0.7-0.4-1l1-0.3c0.4,0.8,0.8,2,0.9,2.7L131.9,134.1z M131.2,125.8l-3.4,0l0-1.4l3.4,0l0-1h1.6v1l2.4,0l0,1.4l-2.4,0
		v1l-1.6,0L131.2,125.8z M134.3,132.3l2.6,0l0-1.2l-2.6,0L134.3,132.3z M134.3,130l2.6,0l0-1.2l-2.6,0L134.3,130z M138.6,125.8
		l-2.5,0v-1.4l2.5,0l0-1l1.7,0l0,1l3.4,0l0,1.4l-3.4,0l0,1h-1.7L138.6,125.8z M138.2,136c1.8,0.6,4.2,1.6,5.5,2.3l-1,1.1
		c-1.2-0.7-3.6-1.8-5.4-2.5L138.2,136z M142.7,134.1c0-0.2-0.1-0.4-0.1-0.7c-2.7,0.3-3.2,0.4-3.4,0.6c-0.1-0.3-0.3-0.9-0.4-1.2
		c0.3-0.1,0.6-0.4,1-0.8c0.2-0.2,0.6-0.6,1-1.2c-1.2,0.1-1.6,0.2-1.8,0.3c-0.1-0.3-0.3-0.9-0.4-1.2c0.2,0,0.5-0.3,0.6-0.6
		c0.2-0.3,1-1.4,1.4-2.6l1.3,0.4c-0.4,0.9-1,1.8-1.6,2.6l1.3-0.1c0.3-0.5,0.6-0.9,0.8-1.4l1.2,0.5c-0.9,1.4-1.9,2.7-3,3.8l1.7-0.2
		c-0.1-0.3-0.3-0.7-0.4-1l1-0.3c0.4,0.8,0.8,1.9,0.9,2.7L142.7,134.1z"
          />
          <path
            fill="#F17752"
            d="M154.8,133.3c-0.1,0.4-0.3,0.8-0.4,1.1l6.6,0l0,3.9c0,0.7-0.1,1.1-0.6,1.3c-0.5,0.2-1.2,0.3-2.2,0.3
		c-0.1-0.4-0.3-1-0.5-1.4c0.6,0,1.2,0,1.4,0c0.2,0,0.3-0.1,0.3-0.2l0-2.5l-2.4,0l0,4h-1.5l0-4l-2.4,0l0,4l-1.5,0l0-4l-2.3,0l0,4.1
		h-1.6l0-5.4l5.1,0c0.1-0.4,0.2-0.7,0.3-1.1l-6.8,0l0-1.3l15.7,0l0,1.3L154.8,133.3z M148,130.4h-1.6l0-3.9l6.8,0v-1.1l-6,0l0-1.3
		l13.7,0l0,1.3l-6.1,0v1.1l7,0l0,3.9l-1.7,0l0-2.7l-5.3,0l0,3.7l-1.6,0l0-3.7l-5.2,0L148,130.4z M148.2,130.6
		c1.1-0.1,2.7-0.3,4.2-0.6l0.1,1c-1.4,0.3-2.7,0.6-3.9,0.8L148.2,130.6z M149.1,128c1.1,0.2,2.5,0.5,3.3,0.9l-0.5,1
		c-0.8-0.3-2.2-0.8-3.3-1L149.1,128z M159.6,131.8c-1-0.3-2.8-0.8-4.2-1l0.4-1c1.3,0.2,3.2,0.5,4.1,0.9L159.6,131.8z M159.6,128.8
		c-1,0.4-2.4,0.8-3.4,1l-0.6-0.8c1-0.2,2.4-0.7,3.2-1L159.6,128.8z"
          />
          <path
            fill="#F17752"
            d="M177,135c-0.5,0.9-1.2,1.6-2,2.2c2.1,0.5,3.9,1,5.3,1.5l-1.5,1.2c-1.4-0.5-3.3-1.1-5.5-1.6
		c-2,1-4.7,1.4-8.1,1.7c-0.1-0.5-0.4-1.1-0.7-1.5c2.4-0.1,4.5-0.4,6.1-0.8c-1.3-0.3-2.6-0.5-3.9-0.7c0.5-0.6,1-1.2,1.5-1.9l-3.7,0
		l0-1.4l4.6,0c0.4-0.6,0.7-1.2,1-1.8l1.7,0.4c-0.2,0.5-0.5,1-0.8,1.4l4.8,0c0.1-0.3,0.3-0.7,0.4-1l1.6,0.5c-0.1,0.2-0.1,0.4-0.2,0.6
		l2.9,0v1.4L177,135z M169.6,125.6l-4.8,0l0-1.5l15.4,0l0,1.5l-5,0l0,1.3l4.3,0l0,4.8l-13.9,0l0-4.8l3.9,0L169.6,125.6z
		 M167.3,130.3l2.4,0l0-2.1l-2.4,0L167.3,130.3z M170.1,135c-0.3,0.4-0.5,0.8-0.8,1.1c1.2,0.2,2.4,0.4,3.6,0.7
		c0.8-0.5,1.5-1.1,2.1-1.8L170.1,135z M171.2,130.3l2.5,0l0-2.1l-2.5,0L171.2,130.3z M173.7,125.6l-2.5,0v1.3l2.5,0V125.6z
		 M175.3,128.2l0,2.1l2.6,0l0-2.1L175.3,128.2z"
          />
          <path
            fill="#F17752"
            d="M198.8,126.2c0,0,0,0.6,0,0.8c-0.3,8.1-0.5,10.9-1.2,11.8c-0.5,0.6-0.9,0.8-1.6,0.8c-0.6,0.1-1.7,0.1-2.7,0
		c0-0.5-0.2-1.2-0.5-1.6c1.2,0.1,2.2,0.1,2.6,0.1c0.4,0,0.6-0.1,0.8-0.3c0.6-0.6,0.8-3.3,1-10.1l-4.2,0c-0.5,1.2-1.1,2.2-1.6,3
		c-0.3-0.3-0.9-0.7-1.3-0.9l0,8.3l-4.9,0v1.4l-1.5,0l0-13.2l2,0c0.3-0.9,0.5-2.1,0.6-2.9l1.8,0.3c-0.3,0.9-0.6,1.9-0.9,2.6l2.9,0
		l0,3.4c1.2-1.5,2.1-3.9,2.7-6.3l1.6,0.4c-0.2,0.8-0.5,1.7-0.7,2.4L198.8,126.2z M188.5,136.6l0-4l-3.3,0l0,4L188.5,136.6z
		 M185.1,127.8l0,3.4l3.3,0l0-3.4L185.1,127.8z M194.5,135.2c-0.5-1.1-1.7-2.9-2.6-4.2l1.3-0.7c1,1.2,2.2,3,2.7,4L194.5,135.2z"
          />
          <path
            fill="#F17752"
            d="M207.2,134.6c-0.3-0.5-0.9-1.4-1.4-2.1l0,7.4l-1.6,0l0-7.3c-0.7,1.6-1.5,3.2-2.3,4.2c-0.2-0.5-0.6-1.2-0.8-1.5
		c1.1-1.2,2.2-3.4,2.9-5.3l-2.6,0l0-1.6l2.8,0l0-2.4c-0.8,0.2-1.7,0.3-2.4,0.4c-0.1-0.4-0.3-0.9-0.5-1.3c2-0.3,4.3-0.8,5.6-1.4
		l1.2,1.3c-0.6,0.3-1.4,0.5-2.2,0.7l0,2.8l2.1,0l0,1.6l-2.1,0v0.8c0.5,0.5,2.1,2,2.4,2.4L207.2,134.6z M217.8,138.3l0,1.4l-10.7,0
		l0-1.4l4.8,0l0-1.2l-3.7,0l0-1.3l3.7,0v-1.1l-3.6,0l0-5.8l3.6,0v-1l-4.2,0v-1.3l4.2,0v-1c-1.2,0.1-2.5,0.1-3.6,0.1
		c0-0.3-0.2-0.9-0.4-1.2c3-0.1,6.6-0.4,8.6-0.8l1,1.2c-1.1,0.3-2.5,0.4-4,0.6v1.1l4,0v1.3l-4,0v1l3.7,0l0,5.8l-3.7,0l0,1.1l3.7,0
		v1.3l-3.7,0l0,1.2L217.8,138.3z M209.7,131.3l2.1,0v-1.2l-2.1,0L209.7,131.3z M211.8,133.5v-1.2l-2.1,0v1.2L211.8,133.5z
		 M215.6,132.3l-2.2,0l0,1.2l2.2,0V132.3z M213.4,130.1l0,1.2l2.2,0l0-1.2L213.4,130.1z"
          />
          <path
            fill="#F17752"
            d="M222.6,132.3c-0.4,2-1.2,4.5-2.2,5.8c-0.1-0.5-0.5-1.2-0.7-1.7c0.8-1,1.5-2.9,1.8-4.5L222.6,132.3z
		 M221.2,128.9c-0.2-1.1-0.7-2.7-1.2-4l1.3-0.3c0.5,1.3,1,2.9,1.2,3.9L221.2,128.9z M225.1,131.9c0.4,0.5,1.8,2.9,2.2,3.5l-1.2,1.2
		c-0.3-0.9-1.2-2.8-1.8-3.8l0,7.1l-1.5,0l0-9l-2.8,0l0-1.6l2.8,0l0-6h1.5l0,6l2.4,0l0,1.6l-2.4,0v1.5L225.1,131.9z M227.3,124.9
		c-0.5,1.3-1.2,2.9-1.7,3.8l-1.2-0.4c0.5-1,1.1-2.7,1.3-3.9L227.3,124.9z M236.2,132.7l-3.8,0l0,5.4c0,0.9-0.2,1.4-0.8,1.6
		c-0.6,0.3-1.5,0.3-3,0.3c-0.1-0.5-0.3-1.2-0.6-1.6c1,0,2,0,2.3,0c0.3,0,0.4-0.1,0.4-0.4l0-5.3l-3.9,0l0-1.6l3.9,0l0-2.4
		c0.8-0.6,1.7-1.6,2.3-2.4l-5.5,0v-1.5l6.8,0l0.4-0.1l1.2,0.8c-0.9,1.2-2.1,2.6-3.4,3.6l0,2l3.8,0L236.2,132.7z"
          />
          <path
            fill="#F17752"
            d="M244.8,133.8c-0.4-0.6-1.1-1.7-1.8-2.6l0,8.7l-1.7,0l0-7.9c-0.7,1.9-1.6,3.7-2.6,4.8c-0.2-0.5-0.6-1.2-0.9-1.6
		c1.3-1.5,2.6-4.1,3.2-6.4l-2.7,0v-1.6l2.9,0l0-3.8h1.7l0,3.8l2.4,0l0,1.6l-2.4,0v0.5c0.7,0.7,2.4,2.6,2.8,3.1L244.8,133.8z
		 M254.6,128.8h-1.8l0,9c0,1.1-0.3,1.5-0.9,1.8c-0.6,0.3-1.7,0.3-3.3,0.3c-0.1-0.5-0.4-1.2-0.6-1.7c1.1,0,2.2,0,2.5,0
		c0.3,0,0.5-0.1,0.5-0.4l0-6.7c-1.4,2.4-3.3,4.7-5.1,6.1c-0.3-0.4-0.8-1-1.2-1.4c2.2-1.5,4.5-4.3,5.8-7.1l-4.6,0l0-1.6l5.1,0l0-3.7
		l1.8,0l0,3.7h1.8L254.6,128.8z"
          />
          <path
            fill="#F17752"
            d="M37.9,153.8c-0.4,2-1.1,4.5-2.1,5.8c-0.1-0.6-0.5-1.4-0.8-1.9c0.7-1,1.5-2.8,1.7-4.3L37.9,153.8z M40.4,153.4
		c0.4,0.5,1.7,2.9,1.9,3.4l-1.2,1.3c-0.3-0.9-1-2.7-1.5-3.7l0,7l-1.6,0l0-9l-2.8,0l0-1.6l2.8,0l0-6l1.6,0l0,6l2.8,0l0,1.6l-2.8,0
		l0,1.4L40.4,153.4z M36.2,150.5c-0.1-1.1-0.5-2.8-0.9-4.1l1.2-0.3c0.5,1.3,0.9,2.9,1,4L36.2,150.5z M42.6,146.4
		c-0.5,1.4-1,3-1.5,4.1l-1.1-0.3c0.4-1.1,0.9-2.9,1.1-4.1L42.6,146.4z M49.5,156.5l0,5l-1.6,0l0-4.7l-5.3,1l-0.3-1.5l5.6-1l0-10.2
		l1.6,0l0,10l2-0.3l0.2,1.5L49.5,156.5z M45.7,153.9c-0.6-0.6-1.9-1.6-3-2.2l0.8-1.2c1,0.6,2.4,1.4,3,2L45.7,153.9z M46.4,149.6
		c-0.6-0.7-1.8-1.7-2.8-2.3l0.8-1.1c1,0.6,2.2,1.5,2.8,2.2L46.4,149.6z"
          />
          <path
            fill="#F17752"
            d="M54.6,160.8c1.4-0.5,2.2-1.3,2.3-2.4c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.5-1.5-1.4c0-0.9,0.7-1.4,1.5-1.4
		c1.1,0,1.7,0.9,1.7,2.3c0,2-1.3,3.5-3.3,4.2L54.6,160.8z"
          />
          <path
            fill="#F17752"
            d="M67.6,145.5c-0.5,1.3-1.1,2.6-1.8,3.9l0,12h-1.6l0-9.6c-0.5,0.7-1,1.3-1.5,1.8c-0.2-0.4-0.6-1.3-0.9-1.7
		c1.7-1.7,3.3-4.3,4.3-6.9L67.6,145.5z M75.8,159.8c1.1,0,1.2-0.5,1.4-2.5c0.4,0.3,1,0.5,1.5,0.6c-0.3,2.6-0.8,3.4-2.8,3.4l-4.4,0
		c-2.3,0-3-0.6-3-2.8l0-5.5l-1.6,0.6l-0.7-1.5l2.3-0.9l0-4.5h1.6l0,3.9l2.3-0.9l0-4.8l1.5,0l0,4.2l2.7-1.1l0.2-0.2l1.3,0.4l-0.1,0.3
		c-0.1,2.6-0.3,6-0.6,8.1l-1.4-0.4c0.2-1.6,0.3-4.2,0.4-6.4l-2.5,1l0,6.5l-1.5,0l0-5.9l-2.3,0.9l0,6.1c0,1,0.2,1.3,1.5,1.3
		L75.8,159.8z"
          />
          <path
            fill="#F17752"
            d="M83.6,150.5c-0.4,2.1-1,4.6-1.9,6.1L80,156c1-1.5,1.7-3.9,2-5.9L83.6,150.5z M90.9,159.7c1,0,1.2-0.6,1.3-3.3
		c0.4,0.3,1.2,0.6,1.6,0.7c-0.3,3.2-0.8,4.2-2.8,4.2l-3.4,0c-2.1,0-2.8-0.6-2.8-2.7v-0.3c-1.2,0.8-2.4,1.5-3.7,2.2
		c-0.3-0.4-0.7-1-1.1-1.3c1.7-0.8,3.3-1.7,4.8-2.9l0-7.2l1.8,0l0,5.7c3-2.6,5.3-5.8,6.8-8.9l1.7,0.7c-2,3.8-4.8,7.4-8.5,10.3l0,1.6
		c0,0.9,0.2,1,1.2,1L90.9,159.7z M89.3,149.6c-1-0.9-2.9-2.3-4.4-3.4L86,145c1.5,1,3.4,2.4,4.4,3.2L89.3,149.6z M94,151
		c1.2,1.7,2.3,4,2.8,5.5l-1.6,0.8c-0.4-1.6-1.6-3.9-2.7-5.7L94,151z"
          />
          <path
            fill="#F17752"
            d="M104.8,155.9c-1.3,2.2-3.3,4-5.5,5.3c-0.3-0.4-0.8-1-1.2-1.4c2-1,4.1-2.6,5.2-4.5L104.8,155.9z M104,146
		c-1.2,1.5-3.1,3-4.7,4c-0.3-0.4-0.8-0.9-1.2-1.2c1.5-0.8,3.4-2.2,4.4-3.5L104,146z M104.3,150.9c-1.2,1.7-3.1,3.2-4.8,4.2
		c-0.3-0.4-0.8-0.9-1.2-1.3c1.6-0.8,3.5-2.2,4.5-3.7L104.3,150.9z M108.6,159.2c-1.2,0.9-3,1.8-4.5,2.3c-0.2-0.3-0.7-0.9-1-1.2
		c1.5-0.5,3.3-1.4,4.2-2.1L108.6,159.2z M108.2,148.7c0.1-0.5,0.2-1,0.3-1.4l-4,0l0-1.4l10.1,0l0,1.4l-4.2,0c-0.2,0.5-0.3,1-0.5,1.4
		l4,0l0,9.3l-8.7,0l0-9.3L108.2,148.7z M112.3,155.2l-5.4,0l0,1.5l5.4,0L112.3,155.2z M112.3,152.6l-5.4,0l0,1.5l5.4,0L112.3,152.6z
		 M112.3,149.9l-5.4,0l0,1.5l5.4,0L112.3,149.9z M111.4,158.3c1.2,0.6,2.8,1.5,3.6,2.2l-1.3,1c-0.7-0.6-2.3-1.7-3.5-2.3L111.4,158.3
		z"
          />
          <path
            fill="#F17752"
            d="M122.7,157.2l0.2,1.4c-2.3,0.7-4.7,1.5-6.5,2.1l-0.4-1.5l0.8-0.2l0-6h1.3l0,5.7l1-0.3l0-6.9h-2.3l0-5.6l5.6,0
		l0,5.6l-1.9,0l0,2.2l2,0l0,1.5l-2,0l0,2.8L122.7,157.2z M118.2,149.9l2.7,0l0-2.7l-2.7,0L118.2,149.9z M126.6,147.5
		c-0.5,2.8-1.6,4.8-3.4,5.9c-0.2-0.3-0.6-0.8-0.9-1.1c1.1-0.7,2-2,2.5-3.6l-2,0l0-1.4l2.5,0l0.3,0L126.6,147.5z M123.7,154l8.1,0
		l0,7.4l-1.6,0l0-0.5l-5,0l0,0.6l-1.5,0L123.7,154z M130.2,159.5l0-1.5l-5,0l0,1.5L130.2,159.5z M125.2,155.4l0,1.4l5,0l0-1.4
		L125.2,155.4z M132.5,147.4c-0.8,0.7-1.7,1.5-2.5,2.1c0.8,1.1,1.7,2,2.9,2.4c-0.3,0.3-0.8,0.9-1,1.3c-1.5-0.8-2.7-2.2-3.5-4l0,2.8
		c0,0.7-0.1,1.1-0.6,1.4c-0.5,0.2-1.2,0.3-2.2,0.3c0-0.4-0.2-1-0.4-1.4c0.6,0,1.3,0,1.5,0c0.2,0,0.3-0.1,0.3-0.2l0-7l1.5,0v1
		c0.2,0.8,0.5,1.6,0.9,2.3c0.7-0.6,1.4-1.4,1.9-1.9L132.5,147.4z"
          />
          <path
            fill="#F17752"
            d="M150.5,159l0,1.7l-16.1,0l0-1.7l6.6,0l0-13.7h1.8l0,5.3l6.5,0l0,1.7l-6.5,0l0,6.7L150.5,159z"
          />
          <path fill="#F17752" d="M168.6,152.2v1.8l-16.4,0v-1.8L168.6,152.2z" />
          <path
            fill="#F17752"
            d="M177.3,157.5c-1.4,0.2-2.8,0.5-4.2,0.7l0,3h-1.6l0-2.8l-1.2,0.2l-0.3-1.6l1.5-0.2l0-10.2l0.1,0
		c1.7-0.5,3.6-1.2,4.7-1.8l1.3,1.3c-1.3,0.6-2.9,1.1-4.5,1.5l0,1.6l3.8,0l0,1.5l-3.8,0v2.2l3.8,0v1.5l-3.8,0l0,2.3
		c1.3-0.2,2.7-0.4,4.1-0.6L177.3,157.5z M185.5,153.4c-0.5,2.1-1.4,3.8-2.6,5.1c1,0.8,2.3,1.3,3.8,1.6c-0.3,0.3-0.8,1-1,1.4
		c-1.5-0.4-2.8-1.1-3.9-2c-1.3,1-2.7,1.6-4.4,2.1c-0.1-0.5-0.5-1.1-0.9-1.4c1.5-0.4,2.9-0.9,4.1-1.8c-0.9-1-1.7-2.3-2.2-3.7l0.9-0.2
		h-1.5v-1.4l6.4,0l0.3-0.1L185.5,153.4z M180.5,147.9c0,1.7-0.4,3.7-2.3,5c-0.2-0.3-0.9-0.9-1.2-1.1c1.7-1.2,2-2.7,2-4l0-2.2l5.3,0
		l0,4.4c0,0.5,0.1,0.6,0.3,0.6h1c0.2,0,0.6,0,0.9-0.1c0,0.4,0.1,1,0.1,1.3c-0.2,0.1-0.6,0.1-1,0.1l-1.2,0c-1.4,0-1.7-0.6-1.7-2
		l0-2.9l-2.2,0V147.9z M179.7,154.5c0.5,1.1,1.1,2.1,1.9,2.9c0.8-0.8,1.4-1.8,1.8-2.9L179.7,154.5z"
          />
          <path
            fill="#F17752"
            d="M194.9,151.5c0,0,0,0.5,0,0.7c-0.1,5.8-0.3,7.8-0.7,8.4c-0.3,0.4-0.6,0.6-1.1,0.6c-0.4,0.1-1.1,0.1-1.7,0
		c0-0.4-0.1-1-0.4-1.5c0.6,0.1,1.1,0.1,1.4,0.1c0.2,0,0.3-0.1,0.5-0.3c0.3-0.4,0.4-2.1,0.5-6.7l-1.7,0c-0.1,2.7-0.5,5.8-2.5,8.5
		c-0.3-0.3-0.8-0.7-1.2-1c2-2.8,2.2-6,2.2-8.5l0-2.6l-1.8,0l0-1.5l3.3,0c-0.2-0.7-0.5-1.7-0.9-2.4l1.5-0.5c0.4,0.8,0.8,1.7,1,2.4
		l-1.4,0.5l3.6,0l0,1.5l-3.7,0l0,2.1L194.9,151.5z M197.8,148.8c-0.5,1-1.1,1.9-1.7,2.6c-0.3-0.3-1-0.8-1.3-1
		c1.3-1.3,2.3-3.3,2.8-5.4l1.6,0.3c-0.2,0.7-0.4,1.4-0.6,2l5.9,0l0,1.5L197.8,148.8z M204.4,153.4c-0.8,0.8-1.7,1.6-2.6,2.2
		c0.6,1.9,1.5,3.4,2.8,4.3c-0.4,0.3-0.9,0.9-1.2,1.4c-2.3-1.8-3.4-5.2-4-9.4c-0.5,0.1-1,0.2-1.4,0.3l0,6.8l2.5-1
		c0,0.5,0.1,1.2,0.2,1.5c-3.2,1.5-3.8,1.7-4.1,2c-0.1-0.3-0.6-1-0.8-1.2c0.3-0.3,0.7-0.8,0.7-1.7l0-7.4c2.3-0.5,4.8-1.2,6.3-1.9
		l1.3,1.2c-0.9,0.4-2,0.8-3.2,1.1c0.1,0.9,0.3,1.8,0.5,2.6c0.7-0.6,1.4-1.3,1.8-1.8L204.4,153.4z"
          />
          <path
            fill="#F17752"
            d="M211.7,156.3c-0.2-0.6-0.8-1.5-1.3-2.4l0,7.7l-1.6,0l0-7.5c-0.6,1.7-1.3,3.4-2.1,4.5c-0.1-0.5-0.5-1.2-0.8-1.6
		c0.9-1.2,1.9-3.4,2.5-5.3l-2.2,0v-1.5l2.6,0l0-2.6c-0.7,0.1-1.3,0.2-2,0.3c-0.1-0.4-0.3-0.9-0.4-1.3c1.8-0.3,3.8-0.8,5.1-1.4
		l0.9,1.4c-0.6,0.3-1.3,0.4-2,0.6l0,3l2.2,0v1.5h-2.2v0.4c0.5,0.6,1.9,2.4,2.2,2.9L211.7,156.3z M222.5,159.7v1.5l-10.3,0v-1.5
		l4.5,0v-2.1l-3.5,0l0-1.4l3.5,0l0-1.9c-1,0.1-2,0.2-3,0.2c0-0.4-0.2-0.9-0.4-1.3c2.5-0.2,5.5-0.5,7.2-1l1.1,1.3
		c-0.9,0.3-2.1,0.4-3.2,0.6l0,2.1l3.5,0v1.4l-3.5,0l0,2.1L222.5,159.7z M221.6,151.8l-8.3,0l0-5.9l8.3,0L221.6,151.8z M220,147.3
		l-5.1,0l0,3l5.1,0L220,147.3z"
          />
          <path
            fill="#F17752"
            d="M228,155.3c1.6,0,2.8,1.3,2.8,2.8c0,1.5-1.2,2.8-2.8,2.8c-1.5,0-2.8-1.3-2.8-2.8
		C225.1,156.5,226.4,155.3,228,155.3z M227.9,159.8c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7
		C226.2,159,227,159.8,227.9,159.8z"
          />
        </g>
      </svg>
    );
  }
}

export default DialogKText;



// WEBPACK FOOTER //
// ./src/storyC/components/DialogKText.tsx